import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Stack } from '@mui/material';
import { PurchaseOrderDetailsContext, PurchaseOrderDetailsValues } from '../../contexts/PurchaseOrderDetailsContext';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { CloseDialogAction } from '../../../../components/shared/dialogs/CloseDialogAction';

export const PurchaseOrderDetailsShowAdjustInstructionsModal = () => {
  const { showAdjustInstructionModal, closeConfirmModal } = useContext(PurchaseOrderDetailsContext) as PurchaseOrderDetailsValues;
  const { t } = useTranslation('purchaseOrderDetails');
  return (
    <Dialog onClose={closeConfirmModal}
      open={showAdjustInstructionModal}>
      <DialogTitle>
        {t('confirmAdjustInstructionsModal.title')}
        <CloseDialogAction onCancel={closeConfirmModal} />
      </DialogTitle>
      <DialogContent>
        <Typography>
          {t('confirmAdjustInstructionsModal.body')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Stack direction={{ xs: 'column', md: 'row' }}
          gap='6px'
          width='30%'>
          <Button variant='primary'
            fullWidth
            size="lg"
            onClick={closeConfirmModal}>
            {t('confirmAdjustInstructionsModal.confirm')}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};